export default __webpack_public_path__ + "static/media/cart.846f7e96.svg";